"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Robot___StyledSvg",
  componentId: "sc-19nfai4-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Robot(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M219.041 190.468v-44.973c-11.931-6.902-19.959-19.802-19.959-34.577C199.082 88.872 216.954 71 239 71s39.918 17.872 39.918 39.918c0 14.775-8.028 27.675-19.96 34.577v44.91l99.542-.158c66.845 5.48 119.5 61.501 119.5 129.859 0 68.357-52.655 124.379-119.5 129.48l-239 .378C52.655 444.484 0 388.464 0 320.106s52.655-124.38 119.5-129.48l99.541-.158zm0 40.202H129c-49.477 0-89.587 40.268-89.587 89.941s40.11 89.94 89.587 89.94H347.99c49.478 0 89.587-40.267 89.587-89.94 0-49.673-40.11-89.94-89.587-89.94H219.041zM129.353 370.13c-27.348 0-49.518-22.396-49.518-50.023 0-27.627 22.17-50.024 49.518-50.024s49.518 22.397 49.518 50.024c0 27.627-22.17 50.023-49.518 50.023zm.505-30.317c10.884 0 19.706-8.823 19.706-19.706 0-10.884-8.822-19.706-19.706-19.706-10.883 0-19.706 8.822-19.706 19.706 0 10.883 8.823 19.706 19.706 19.706zm217.778 30.317c-27.348 0-49.518-22.396-49.518-50.023 0-27.627 22.17-50.024 49.518-50.024s49.518 22.397 49.518 50.024c0 27.627-22.17 50.023-49.518 50.023zm.506-30.317c10.883 0 19.706-8.823 19.706-19.706 0-10.884-8.823-19.706-19.706-19.706-10.884 0-19.706 8.822-19.706 19.706 0 10.883 8.822 19.706 19.706 19.706z"
  }));
}

var _default = Robot;
exports["default"] = _default;